<div class="courseDetailsScreen">
    <app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
  <div class="courseDetailsContainer">
    <div class="columns toolbar">
      <div class="column1">
        <div class="bpt-main-content-container" style="overflow-y: auto;">
          <div *ngIf="isQuizReadOnly">
              <app-quiz-completion 
                  [quizDataToDisplay]="quizData" 
                  [quizAnswers]="quizAnswers" 
                  [isQuizReadOnly]="isQuizReadOnly">
              </app-quiz-completion>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
